var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: _vm.$t("blExchangeAppointment.forespeakCommon"),
                "is-show-follow": false,
              },
              on: { opened: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c(
                  "el-form",
                  { ref: "form", attrs: { rules: _vm.rules, model: _vm.form } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "vvLBlNo",
                                  label: _vm.$t(
                                    "blExchangeAppointment.voyageNoBlNo"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: true,
                                    type: "textarea",
                                    autosize: { minRows: 2, maxRows: 4 },
                                  },
                                  model: {
                                    value: _vm.vvLBlNo,
                                    callback: function ($$v) {
                                      _vm.vvLBlNo = $$v
                                    },
                                    expression: "vvLBlNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "paymentStatus",
                                  label: _vm.$t(
                                    "blExchangeAppointment.paymentStatus"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: true,
                                      placeholder: _vm.$t(
                                        "blExchangeAppointment.select"
                                      ),
                                    },
                                    model: {
                                      value: _vm.form.paymentStatus,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "paymentStatus", $$v)
                                      },
                                      expression: "form.paymentStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.paymentStatusList,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.codeValue,
                                        attrs: {
                                          value: Number(item.codeValue),
                                          label:
                                            _vm.language === "zh"
                                              ? item.displayValueCn
                                              : item.displayValue,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "forespeakStatus",
                                  label: _vm.$t(
                                    "blExchangeAppointment.forespeakStatus"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: true,
                                      placeholder: _vm.$t(
                                        "blExchangeAppointment.select"
                                      ),
                                    },
                                    model: {
                                      value: _vm.form.forespeakStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "forespeakStatus",
                                          $$v
                                        )
                                      },
                                      expression: "form.forespeakStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.forespeakStatusList,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.codeValue,
                                        attrs: {
                                          value: Number(item.codeValue),
                                          label:
                                            _vm.language === "zh"
                                              ? item.displayValueCn
                                              : item.displayValue,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "doType",
                                  label: _vm.$t("blExchangeAppointment.doType"),
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.form.doType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "doType", $$v)
                                      },
                                      expression: "form.doType",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      { attrs: { disabled: true, label: 0 } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "blExchangeAppointment.electronicBill"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-radio",
                                      { attrs: { disabled: true, label: 1 } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "blExchangeAppointment.paperBill"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "invoiceTitle",
                                  label: _vm.$t(
                                    "blExchangeAppointment.invoiceTitle"
                                  ),
                                },
                              },
                              [
                                _c("el-autocomplete", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 60,
                                    "fetch-suggestions": _vm.querySearchInvoice,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.invoiceTitle,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "invoiceTitle", $$v)
                                    },
                                    expression: "form.invoiceTitle",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "paymentMethod",
                                  label: _vm.$t(
                                    "blExchangeAppointment.paymentMethod"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    model: {
                                      value: _vm.form.paymentMethod,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "paymentMethod", $$v)
                                      },
                                      expression: "form.paymentMethod",
                                    },
                                  },
                                  _vm._l(_vm.edoPaymentMethod, function (item) {
                                    return _c("el-option", {
                                      key: item.codeValue,
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "blExchangeAppointment.select"
                                        ),
                                        value: Number(item.codeValue),
                                        label:
                                          _vm.language === "zh"
                                            ? item.displayValueCn
                                            : item.displayValue,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "attachment",
                                  label: _vm.$t(
                                    "blExchangeAppointment.bankSlip"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    ref: "upload",
                                    staticClass: "upload-demo",
                                    attrs: {
                                      action: "",
                                      multiple: "",
                                      limit: 1,
                                      "http-request": _vm.uploadFile,
                                      "on-remove": _vm.handleRemove,
                                      "before-remove": _vm.beforeRemove,
                                      accept: _vm.acceptList,
                                      "file-list": _vm.fileList,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-upload2",
                                          size: "small",
                                          type: "primary",
                                          plain: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "blExchangeAppointment.selectFile"
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    !_vm.form.attachment ||
                                    _vm.form.attachment.length === 0
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "blExchangeAppointment.notFileSelected"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  prop: "mail",
                                  label: _vm.$t("blExchangeAppointment.mail"),
                                },
                              },
                              [
                                _c("el-autocomplete", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 60,
                                    "fetch-suggestions": _vm.querySearchMail,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.mail,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "mail", $$v)
                                    },
                                    expression: "form.mail",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "identifier",
                                  label: _vm.$t(
                                    "blExchangeAppointment.identifier"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 50,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.identifier,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "identifier", $$v)
                                    },
                                    expression: "form.identifier",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "consigneeName",
                                  label: _vm.$t(
                                    "blExchangeAppointment.consigneeName"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 160,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.consigneeName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "consigneeName", $$v)
                                    },
                                    expression: "form.consigneeName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "consigneeAddress",
                                  label: _vm.$t(
                                    "blExchangeAppointment.consigneeAddress"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 160,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.consigneeAddress,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "consigneeAddress",
                                        $$v
                                      )
                                    },
                                    expression: "form.consigneeAddress",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "address",
                                  label: _vm.$t(
                                    "blExchangeAppointment.address"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 100,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.address,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "address", $$v)
                                    },
                                    expression: "form.address",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "phone",
                                  label: _vm.$t("blExchangeAppointment.phone"),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "phone", $$v)
                                    },
                                    expression: "form.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "accountBank",
                                  label: _vm.$t(
                                    "blExchangeAppointment.accountBank"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 50,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.accountBank,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "accountBank", $$v)
                                    },
                                    expression: "form.accountBank",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "invoiceTaxNo",
                                  label: _vm.$t(
                                    "blExchangeAppointment.invoiceTaxNo"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 50,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.invoiceTaxNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "invoiceTaxNo", $$v)
                                    },
                                    expression: "form.invoiceTaxNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "invoiceBankNo",
                                  label: _vm.$t(
                                    "blExchangeAppointment.invoiceBankNo"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "uppercase",
                                      rawName: "v-uppercase",
                                    },
                                    { name: "trim", rawName: "v-trim" },
                                    { name: "fth", rawName: "v-fth" },
                                  ],
                                  attrs: {
                                    maxlength: 50,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.invoiceBankNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "invoiceBankNo", $$v)
                                    },
                                    expression: "form.invoiceBankNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-row", { staticClass: "p-color" }, [
                      _c(
                        "div",
                        [
                          _c(
                            "el-link",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "red",
                              },
                              attrs: { icon: "el-icon-warning-outline" },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "blExchangeAppointment.bankSlipUploadInstructions"
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("blExchangeAppointment.uploadCorrectFile")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("blExchangeAppointment.noNeedForSlip"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("blExchangeAppointment.increaseEfficiency")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("blExchangeAppointment.invoiceInfo"))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { staticClass: "item-button" },
                      [
                        _vm.edoCreditId
                          ? _c(
                              "el-button",
                              {
                                staticClass: "btn-info-primary",
                                on: { click: _vm.handleCancel },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("btn.cancelAppointment")) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            on: { click: _vm.handleSave },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("btn.forespeakSave")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }